import * as React from 'react';
import TollTwoToneIcon from '@mui/icons-material/TollTwoTone';

export const getCoinsIcon = () => (<TollTwoToneIcon sx={{color: 'gold'}}/>)